/* Device-local favourites. No account, tracking or external requests. */
(() => {
  if (window.cbCoffeeTilesReady) return;
  window.cbCoffeeTilesReady = true;
  const key = 'cb-saved-coffees-v1';
  const read = () => { try { const v = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v.filter(x => typeof x === 'string') : []; } catch { return []; } };
  function sync() {
    const saved = read();
    document.querySelectorAll('.cb-tile__save').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved.includes(button.dataset.productId)));
      button.title = saved.includes(button.dataset.productId) ? 'Saved on this device — click to remove' : 'Save on this device';
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('.cb-tile__save');
    if (!button) return;
    const saved = read(), id = button.dataset.productId;
    try {
      localStorage.setItem(key, JSON.stringify(saved.includes(id) ? saved.filter(x => x !== id) : [...saved, id]));
      sync();
    } catch {
      button.title = 'Saving is unavailable in this browser';
      button.setAttribute('aria-label', 'Saving is unavailable in this browser');
    }
  });
  sync();
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('storage', sync);
  new MutationObserver(records => { if (records.some(r => r.addedNodes.length)) sync(); }).observe(document.body, {childList:true,subtree:true});
})();
